@if (routerLink()) {
  <a [routerLink]="routerLink()" [queryParams]="queryParams()" [class]="twClasses()"> {{ content() }} </a>
} @else {
  <button [disabled]="disabled()" [class]="twClasses()">{{ content() }}</button>
}
